<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import CatalogForm from '@/components/shared/CatalogForm.vue'
import { menuRoutesEnum } from '@/router'

const router = useRouter()
const show_dialog = ref(false)
const translations = ref({})

onMounted(() => {
  const allowed = localStorage.getItem('allow_lrw_denied_page') === 'true'
  show_dialog.value = allowed
  translations.value = JSON.parse(localStorage.getItem('catalog_lrw_translation'))
  localStorage.removeItem('allow_lrw_denied_page')
  localStorage.removeItem('catalog_lrw_translation')

  const isNamedPopup = window.name === 'catalogTabTarget'
  const isOpenedByWindowOpen = window.opener != null

  if (!allowed) {
    if (isNamedPopup) {
      window.close()
      return
    }

    if (isOpenedByWindowOpen) {
      router.replace({ path: menuRoutesEnum.HOME })
      return
    }

    router.replace({ path: menuRoutesEnum.HOME })
    return
  }
})
</script>
<template>
  <div>
    <catalog-form v-if="show_dialog" :translations="translations" />
  </div>
</template>
